import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectULTemplateList = createSelector(
  [
    (store: RootState) => store.templateList.templatesUserLocation,
    (store: RootState) => store.templateList.ulSearchText,
    (store: RootState) => store.templateList.filterForFileTemplates,
  ],
  (templates, searchText, filter) => templates.filter(
    ({ name, assignedTo }) => {
      if (
        searchText
        && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
      ) {
        return false;
      }
      if (filter === "location" && assignedTo != "location") {
        return false
      }
      if (filter === "user" && assignedTo != "user") {
        return false
      }
      return true;
    })
);